import { Injectable } from "@angular/core";
import { ID2XClientLoginResponse } from "../interfaces/auth-api.interface";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class D2XAuthService {

    public subscriptions = new Subscription();

    constructor(
        private router: Router
    ) {
        this.checkLoginStatus();
    }
    public loginData: ID2XClientLoginResponse | null = null;

    public setLoginData(loginData: ID2XClientLoginResponse) {
        this.loginData = loginData;
        localStorage.setItem('user_d2x', JSON.stringify(this.loginData));
    }

    public setLoginSessionStorage(loginData: string) {
        this.loginData = JSON.parse(loginData);
        sessionStorage.setItem('user_d2x', JSON.stringify(this.loginData));
    }


    public removeLoginData() {
        console.log('removeLoginData');
        this.loginData = null;
        localStorage.removeItem('user_d2x');
    }

    public checkLoginStatus() {
        const loginData = localStorage.getItem('user_d2x');

        console.log('loginData', loginData);
        if (loginData) {
            this.loginData = JSON.parse(loginData);
            return true;
        }
        return false;
    }

    public isLogin() {
        const loginData = localStorage.getItem('user_d2x');

        if (loginData) {
            return true;
        }
        return false;
    }

    /**
     * 로컬 스토리지에서 리프레시 토큰을 가져옵니다.
     * @returns 리프레시 토큰 또는 토큰이 없으면 null
     */
    public getRefreshToken(): string | null {
        const userData = localStorage.getItem('user_d2x');
        if (userData) {
            const parsedData = JSON.parse(userData);
            return parsedData.refresh_token || null;
        }
        return null;
    }

    public getAccessToken(): string | null {
        const userData = localStorage.getItem('user_d2x');
        if (userData) {
            const parsedData = JSON.parse(userData);
            return parsedData.access_token || null;
        }
        return null;
    }

    public getSessionId(): string | null {
        const userData = localStorage.getItem('user_d2x');
        if (userData) {
            const parsedData = JSON.parse(userData);
            return parsedData.session_id || null;
        }
        return null;
    }


    public logout() {
        this.removeLoginData();
    }

    public logoutAndRedirect() {
        this.removeLoginData();
        this.router.navigateByUrl('/d2x/login');
    }


}